<script>
    import {Bar} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {hexToRgba} from '@coreui/coreui/dist/js/coreui-utilities'

    export default {
        components: {
            hexToRgba,
            CustomTooltips
        },
        extends: Bar,
        mounted() {
            this.renderChart(
                {
                    labels: ['2017', '2018'],
                    datasets: [
                        {
                            label: 'Productores que no asistieron a comercializar',
                            backgroundColor: hexToRgba('#ff9c00', 70),
                            fill: true,
                            data: [13, 36]
                        },
                        {
                            label: 'Productores que anteriormente comercializan productos',
                            backgroundColor: hexToRgba('#24dcff', 70),
                            fill: true,
                            data: [33, 33]
                        },
                        {
                            label: 'Total de Comerciantes que asistieron a comercializar productos',
                            backgroundColor: hexToRgba('#d5ff2c', 70),
                            fill: true,
                            data: [46, 69]
                        }
                    ]
                },
                {
                    responsive: true,
                    scales: {
                        yAxes: [{
                            stacked: false,
                            ticks: {
                                precision: 0,
                                beginAtZero: true,
                                suggestedMax: 100
                            }
                        }]
                    },
                    maintainAspectRatio: true,
                    tooltips: {
                        enabled: false,
                        custom: CustomTooltips,
                        intersect: false,
                        mode: 'index',
                        position: 'nearest',
                        callbacks: {
                            labelColor: function (tooltipItem, chart) {
                                return {backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor}
                            }
                        }
                    }
                }
            )
        }
    }
</script>
